import React, { useState } from 'react';
import { SensePortal } from './PageComponents/SensePortalComponent';
import {
  Announcement,
  IAnnouncement
} from './PageComponents/AnnouncementComponent';
import { PasswordResetRequest } from './PageComponents/PasswordResetComponent';
import { intl, Link } from 'ehs-react';
import { usePortletStore } from '../App';

const Steps = {
  EmailSetup: 0,
  RequestSend: 1
};

const PasswordResetState: {
  progress: number;
  announcement: IAnnouncement;
}[] = [
  {
    progress: 66,
    announcement: {
      headingText: intl('resetpasswordportlet.state1.announcement.headingtext'),
      attentionText: intl(
        'resetpasswordportlet.state1.announcement.attentionText'
      ),
      image: 'lock'
    }
  },
  {
    progress: 100,
    announcement: {
      headingText: intl('resetpasswordportlet.state2.announcement.headingtext'),
      attentionText: intl(
        'resetpasswordportlet.state2.announcement.attentionText'
      ),
      image: 'auth-email'
    }
  }
];

function PageComponent(): JSX.Element {
  const [step, setStep] = useState<number>(Steps.EmailSetup);
  const [welcomePageUrl] = usePortletStore(state => [
    state.configuration.welcomePageUrl
  ]);

  const onNextPage = () => {
    setStep(Steps.RequestSend);
  };

  return (
    <div className="render-component">
      <SensePortal progress={PasswordResetState[step].progress} />
      <Announcement announcement={PasswordResetState[step].announcement} />
      {step === Steps.EmailSetup && (
        <PasswordResetRequest onNextPage={onNextPage} />
      )}
      <div className="password-reset-button">
        <Link variant="gray" href={welcomePageUrl}>
          {step === Steps.EmailSetup
            ? intl('view.button.cancel')
            : intl('common.continue')}
        </Link>
      </div>
    </div>
  );
}

export const Page = PageComponent;
